import { Tooltip } from '@mui/material';
import { UnitSystem } from '@trackman/baseball-shared-components';
import { Input } from '@trackman/web-shared-components';
import { ReactComponent as InfoIcon } from 'images/szInfoIcon.svg';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { InputWithAdornmentWrapper, TooltipContent } from './InputWithAdornmentStyles';

interface IProps {
  label: string;
  value?: string | number;
  adornmentValue: string;
  onChange: (value: any) => void;
  defaultValue?: string | number | null;
  metrics: UnitSystem;
  ['data-testid']: string;
}

export const InputWithAdornment: React.FC<IProps> = observer((props) => {
  const { label, value, adornmentValue, onChange, defaultValue, metrics, ...rest } = props;

  const getEndAdornmentIcon = () => {
    if (value && defaultValue && Number(value) !== Number(defaultValue)) {
      return (
        <Tooltip
          title={
            <TooltipContent>
              <div>Changed from default</div>
              <div>value: {defaultValue}</div>
            </TooltipContent>
          }
          arrow
          placement='top'
        >
          <InfoIcon />
        </Tooltip>
      );
    }

    return null;
  };

  return (
    <InputWithAdornmentWrapper {...rest}>
      <Input
        label={label}
        value={value}
        width={140}
        onChange={(event) => onChange(event.target.value)}
        InputProps={{ endAdornment: getEndAdornmentIcon() }}
      />
      <Input label='Unit' value={adornmentValue} width={54} inputProps={{ readOnly: true }} />
    </InputWithAdornmentWrapper>
  );
});
